import React, { Fragment } from "react";

export type StepperItem = {
  number: number;
  label: string;
  onClick?: () => void;
};

export type StepperProps = {
  current: number;
  statusSteps: StepperItem[];
};

const Stepper = ({ current, statusSteps }: StepperProps) => (
  <div id="stepper" className="d-flex justify-content-between align-items-center mb-5">
    {statusSteps.map(({ number }) => (
      <Fragment key={number}>
        <div className={`status-step ${current < number ? "inactive" : ""}`}>
          <span>{number}</span>
        </div>
        {number < statusSteps[statusSteps.length - 1].number && (
          <div className={`status-line ${current - 1 < number ? "inactive" : ""}`} />
        )}
      </Fragment>
    ))}
  </div>
);

export default Stepper;
